const sponsers = [
  {
    name: "Google",
    url: "",
    logoUrl: "/img/sponsers/Google.svg",
    backgroundUrl: "/img/sponsers/Rectangle1.svg",
  },

  {
    name: "Amazon",
    url: "",
    logoUrl: "/img/sponsers/Amazon.svg",
    backgroundUrl: "/img/sponsers/Rectangle2.svg",
  },

  {
    name: "Facebook",
    url: "",
    logoUrl: "/img/sponsers/FacebookF.svg",
    backgroundUrl: "/img/sponsers/Rectangle3.svg",
  },

  {
    name: "Adobe",
    url: "",
    logoUrl: "/img/sponsers/Adobe.svg",
    backgroundUrl: "/img/sponsers/Rectangle4.svg",
  },

  {
    name: "Hp",
    url: "",
    logoUrl: "/img/sponsers/HP.svg",
    backgroundUrl: "/img/sponsers/Rectangle5.svg",
  },

  {
    name: "Google",
    url: "",
    logoUrl: "/img/sponsers/Dell.svg",
    backgroundUrl: "/img/sponsers/Rectangle6.svg",
  },

  {
    name: "Netflix",
    url: "",
    logoUrl: "/img/sponsers/NetflixDesktopApp.svg",
    backgroundUrl: "/img/sponsers/Rectangle7.svg",
  },

  {
    name: "Js",
    url: "",
    logoUrl: "/img/sponsers/JsSquared.svg",
    backgroundUrl: "/img/sponsers/Rectangle8.svg",
  },
];

export default sponsers;
